export const GEOGRAPHIES_LOAD_START = 'GEOGRAPHIES_LOAD_START';
export const GEOGRAPHIES_LOAD_SUCCESS = 'GEOGRAPHIES_LOAD_SUCCESS';
export const GEOGRAPHIES_LOAD_FAILURE = 'GEOGRAPHIES_LOAD_FAILURE';
export const GEOGRAPHY_OPTIONS_LOAD_START = 'GEOGRAPHY_OPTIONS_LOAD_START';
export const GEOGRAPHY_OPTIONS_LOAD_SUCCESS = 'GEOGRAPHY_OPTIONS_LOAD_SUCCESS';
export const GEOGRAPHY_OPTION_LOAD_FAILURE = 'GEOGRAPHY_OPTION_LOAD_FAILURE';
export const GEOGRAPHIES_LOCATIONS_LOAD_FAILURE = 'GEOGRAPHIES_LOCATIONS_LOAD_FAILURE';
export const GEOGRAPHIES_LOCATIONS_LOAD_SUCCESS = 'GEOGRAPHIES_LOCATIONS_LOAD_SUCCESS';
export const GEOGRAPHY_SUGGESTED_LOAD_SUCCESS = 'GEOGRAPHY_SUGGESTED_LOAD_SUCCESS';
export const CURRENT_GEOGRAPHY_LOAD_START = 'CURRENT_GEOGRAPHY_LOAD_START';
export const CURRENT_GEOGRAPHY_LOAD_SUCCESS = 'CURRENT_GEOGRAPHY_LOAD_SUCCESS';
export const CURRENT_GEOGRAPHY_LOAD_FAILURE = 'CURRENT_GEOGRAPHY_LOAD_FAILURE';
